// src/services/authService.js
import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getControleCount = async () => {
  return userRequest.get(`${DOMAIN}/api/controle/count`);
};

export const getControle = async (user) => {
    return userRequest.get(`${DOMAIN}/api/controle`);
  };

export const getControleOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/controle/one?id_controle=${id}`);
  };

export const postControle = async (data) => {
  return userRequest.post(`${DOMAIN}/api/controle`, data);
};

export const deletePutControle = async (id) => {
  return userRequest.put(`${DOMAIN}/api/controle/est_supprime?id=${id}`);
};

export const putControle = async (id, data) => {
  return userRequest.put(`${DOMAIN}/api/controle?id_controle=${id}`, data);

}